import { querySuites } from '@/features/suites/data';
import { buildMetricsDateRange } from '@/shared/utils/metricsRange';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { QueryResult, SuiteListItemDto } from '@flowqa/shared';

export const fetchSuitesGrid = async (
  input: GridQueryInput,
  projectId?: string | null,
  organisationId?: string | null,
  includeDeltas = true,
): Promise<QueryResult<SuiteListItemDto>> => {
  const metricsRange = buildMetricsDateRange();
  return await querySuites(projectId ?? undefined, organisationId ?? undefined, {
    ...input,
    ...metricsRange,
    include: {
      project: true,
      latestExecution: true,
      executionStatusCounts: true,
      latestTestResults: { counts: true },
      metrics: true,
      metricDeltas: includeDeltas,
    },
  });
};
